var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"meethead"},[_c('div',{staticClass:"schedule-header"},[(_vm.bannerSrc&&_vm.bannerSrc!=''&&_vm.bannerSrc!=null)?_c('img',{attrs:{"src":_vm.bannerSrc}}):_c('img',{attrs:{"src":require("../../../../assets/m-banner.jpg")}})]),_c('transition',{attrs:{"name":"fade"}},[(_vm.loading)?_c('Loading'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }